module.exports = __webpack_public_path__ + "statics/img/FullChain-4@2x.34dedc37.png";